import { render, staticRenderFns } from "./IMApproval.vue?vue&type=template&id=53188ae4&scoped=true&lang=pug"
import script from "./IMApproval.vue?vue&type=script&lang=js"
export * from "./IMApproval.vue?vue&type=script&lang=js"
import style0 from "./IMApproval.vue?vue&type=style&index=0&id=53188ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53188ae4",
  null
  
)

export default component.exports